import { Button } from '@billda/design-system';
import { ReactNode } from 'react';

interface StepNavigationProps {
  onPrevious?: () => void;
  onNext: () => void;
  nextLabel: string;
  previousLabel?: string;
  disableNext?: boolean;
  disablePrevious?: boolean;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  onSecondary?: () => void;
  secondaryLabel?: string;
  secondaryDisabled?: boolean;
}

export const StepNavigation = ({
  onPrevious,
  onNext,
  nextLabel,
  previousLabel = 'Previous',
  disableNext = false,
  disablePrevious = false,
  startAdornment,
  endAdornment,
  onSecondary,
  secondaryLabel,
  secondaryDisabled = false,
}: StepNavigationProps) => {
  return (
    <div className="mt-6 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        {startAdornment}
        {onPrevious ? (
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={disablePrevious}
            data-testid="step-previous-button"
          >
            {previousLabel}
          </Button>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        {endAdornment}
        <Button
          variant="neutral"
          onClick={onNext}
          disabled={disableNext}
          data-testid="step-next-button"
        >
          {nextLabel}
        </Button>
        {secondaryLabel && onSecondary ? (
          <Button
            variant="success"
            onClick={onSecondary}
            disabled={secondaryDisabled}
            data-testid="secondary-step-button"
          >
            {secondaryLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
